<template>
  <section class="sidebar">
    <div v-if="isAuthenticated">
      <div class="sidebar__logo">
        <img src="../assets/video-btn.svg">
      </div>
      <div :class="isSidebarItemActive ? 'item-is-active' : ''" class="sidebar__link" @click="save">
        <i class="material-icons">save</i>
        <div class="label">Save</div>
      </div>
      <router-link class="sidebar__link item-is-active" to="/project">
        <i class="material-icons">folder</i>
        <div class="label">Projects</div>
      </router-link>
      <router-link v-tooltip.bottom="'edit selected video asset'" :class="isSidebarItemActive ? 'item-is-active' : ''" class="sidebar__link" to="/editor">
        <i class="material-icons">mode_edit</i>
        <div class="label">EDIT</div>
      </router-link>
      <router-link v-tooltip.bottom="'preview selected video asset'" :class="isSidebarItemActive ? 'item-is-active' : ''" class="sidebar__link" to="/show">
        <i class="material-icons">video_label</i>
        <div class="label">PREVIEW</div>
      </router-link>
        <router-link v-tooltip.bottom="'translate asset text entires'" :class="isSidebarItemActive ? 'item-is-active' : ''" class="sidebar__link" to="/translate">
        <i class="material-icons">language</i>
        <div class="label">Translate</div>
      </router-link>
      <router-link v-tooltip.bottom="'export selected video asset'" :class="isSidebarItemActive ? 'item-is-active' : ''" class="sidebar__link" to="/export">
        <i class="material-icons">file_download</i>
        <div class="label">EXPORT</div>
      </router-link>
      <router-link v-if="user.admin" v-tooltip.bottom="'admin users'" class="sidebar__link item-is-active" to="/users">
        <i class="material-icons">person_add</i>
        <div class="label">Users</div>
      </router-link>
      <router-link class="sidebar__link item-is-active" to="/changePassword">
        <i class="material-icons">lock_open</i>
        <div class="label">PASSWORD</div>
      </router-link>
      <div class="sidebar__link item-is-active"  @click="logout()">
        <i class="material-icons">perm_identity</i>
        <div class="label">Logout</div>
      </div>
      <div class="sidebar__link item-is-active"  @click="openDocs()">
        <i class="material-icons">help</i>
        <div class="label">Docs</div>
      </div>
    </div>
    <div v-if="!isAuthenticated">
      <div class="sidebar__logo">
        <img src="../assets/video-btn.svg">
      </div>
      <router-link class="sidebar__link" to="/login">
        <i class="material-icons">perm_identity</i>
        <div class="label">Login</div>
      </router-link>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'sidebar',
    computed: {
      ...mapGetters(['isAuthenticated', 'video', 'user', 'selectedAsset']),
      isSidebarItemActive() {
        return this.selectedAsset.src !== ''
      }
    },
    methods: {
      ...mapActions(['saveAsset', 'logoutUser']),
      save() {
        const asset = { id: this.selectedAsset.id, title: this.selectedAsset.title, src: this.video.src, content: JSON.stringify(this.video) }
        this.saveAsset(asset)
      },
      logout() {
        this.logoutUser()
        this.$router.push('login')
      },
      openDocs() {
        window.open("https://interactivevideo.swisstxt.ch/docs/")
      }
    }
  }

</script>
